<template>
  <div>
    <Header title="教学评价"  route="/new/Home_10013"></Header> 
    <div class="windowtable">
      <!-- 评价指标-->  
			<div class="pjzbClass">				 
				<div  
          v-for="(obj, index) in lstObj"
          :key="index" 
        >
          <div class="jxpjItem">
            <div class="itemTitle">
              {{ obj.ppj23.pjzbmc }} 
            </div>		 
            <div  
              v-for="(objc2, ind) in obj.zb "
              :key="ind" 
            > 
              <div class="itemDsc"> 
                <div
                  class="descTitle" 
                  align="left"
                >
                  {{ ind+1 }}  &nbsp;{{ objc2.cpj23.pjzbmc}}&nbsp;({{ objc2.cpj23.qz *100}}%)
                  
                </div>				 
                <div 
                  class="descContent"
                  align="left" 
                 v-if="objc2.dffs == '1'"
                > 
                <!-- v-if="objc2.dffs == '1'" -->
                    <input 
                      type="text" 
                      v-model="objc2.value"  
                      @blur="shuruzhi(objc2.fz, objc2.value)" 
                      size="3" 
                      maxlength="5"
                    />    
                </div>
                <div 
                  align="left" 
                  v-if="objc2.dffs != '1'"
                  class="descContent"
                >				
                <!-- v-if="objc2.dffs != '1'" -->
                  <div
                    class="contentItem"
                    v-for="(Pj2301, pj2301Ind) in objc2.lstObjXx" 
                    :key="pj2301Ind"
                  >
                      <input type="radio" v-if="Pj2301.issave=='1'" :name="objc2.cpj23.pjzbbh"  @click="choise(Pj2301, objc2, Pj2301.pj2301id)"   checked='checked'/>							 
                      <input type="radio" v-else :name="objc2.cpj23.pjzbbh"  @click="choise(Pj2301, objc2, Pj2301.pj2301id)" />							 
                      {{Pj2301.mc}}（{{Pj2301.fz}}）
                    &nbsp;
                  </div> 
                </div>
              </div> 
            </div>
          </div>
        </div>
          
      </div>
      <!-- 评价建议-->  
      <div v-for="(pjcblb, pjcblbInd) in pjcblb" :key="pjcblbInd">
        <div class="pjjyClass" align="left">
          <div class="pjjyTitle">
            {{pjcblb.jymc }}
          </div>
          <div class="pjjyContent" align="left">
            <textarea rows="5" cols="35" 
              v-model="pjcblb.jynr"  
              :name="pjcblb.pjcblbid" 
              :id="pjcblb.pjcblbid">
            </textarea>
          </div>
        </div> 	 
			</div>
			<br/>
      <div class="pjButton">
        <input type="button"  class="button el-button btnLfte" value="取消" onclick="javascript:window.close();" />

        <div  v-if="this.xjpjData === [] && pj2503.issubmit != '1' ">
          <input type="button"  class="button el-button btnRight" value="提 交" id="sub_btn" @click="submit()" 	/> 
        </div> 
      </div>
    
    </div>

    <!-- <div class="eva-buttons">
      <button class="pre-topic" @click="preTopic()" v-if="evaluateIndex != 0">上一题</button>
      <button
        class="eva-btn"
        @click="nextTopic()"
        v-text="evaluateIndex + 1 == total ? '提交评教' : '下一题'"
        :style="evaluateIndex == 0 ? 'width:100%' : ''"
      ></button>
    </div> -->
  </div>
</template>

<script>
import { Api } from '../../../utils/axios'
export default {
  data() {
    return { 
      lstObj: [],
      pjcblb: [],
      pj25: {},
      pj2503: {},
      pj2201id:this.$route.query.pj2201id
    }
  },
  created() { 
    this.getJspxkc_edit()
  },
  methods: {
    
    async getJspxkc_edit() {
      const params = {
        pj2201id: this.$route.query.pj2201id,
        pj25id: this.$route.query.pj25id 
      }
      const res = await Api.getJspxkcEditApi_10013(params)
      this.lstObj = res.data.lstObj;
      this.pjcblb = res.data.pjcblb;
      this.pj25 = res.data.pj25;
      this.pj2503 = res.data.pj2503;
    }, 
    //选择题
    choise(zbxxItem, zbItem, id) {  
        zbItem.value = id;
        console.log('zbItem: ', {
                zbItem: this.lstObj
            });
    },
    //输入值校验提示
    shuruzhi(fz, val) {
        if (parseInt(val) > parseInt(fz)) {
            Toast.fail('评分值不能大于' + fz);
        } else {
            // this.result = (parseInt(fz) / 100) * parseInt(val);
        }
    },
    async submit() {
      
      // const choicedModelList = this.modelList.filter((item) => !!item);
      // console.log('choicedModelList: ', choicedModelList);
      // if (this.xjpjData.length > choicedModelList.length) {
      //     Toast.fail('请填写完整细节评价');
      //     return false;
      // } 
      const zgpjdata = this.pjcblb.some((item) => {
          return item.jynr === '';
      });
       if (zgpjdata) {
          Toast.fail('请填写完整主观评价');
          return false;
      }
      const obj = {
          lstObj: this.lstObj,
          pjcblb: this.pjcblb,
          pj25: this.pj25,
          pj2503: this.pj2503,
          pj2201id:this.pj2201id
      };
      console.log('obj', obj);
      const res = await Api.saveJspxApi_10013(obj);
      if (res.code == '1') {
        this.$router.go(-1); 
      }
    }
  },
}
</script>

<style lang="less" scoped>
 .windowtable{
   padding: 10px;
   background-color: #2b67e1;
   .pjzbClass{ 
     .jxpjItem{
       margin-bottom: 10px;
      //  width: 100%;
       border-radius: 8px;
       background-color: #fff;
       padding: 16px 15px 16px 24px;
       .itemTitle{
          font-weight: 500;
          font-size: 16px;
          color: #333;
          padding-bottom: 14px;
       }
       .itemDsc{
         background-color: #f9f9f9;
         border: 0.5px solide #e5e5e5;
         border-radius: 4px;
         padding: 14px 12px;
         .descTitle{
          font-weight: 500;
          font-size: 14px;
          color: #333;
          padding-top: 1.5px;
         }
         .descContent{
          font-weight: 400;
          font-size: 14px;
          color: #666;
          
          .contentItem{
            padding: 12px 0 0 20px;
            border-bottom: 0.5px dashed #e5e5e5;
          }
         }
       }
     }
   }
   .pjjyClass{
     margin-bottom: 10px;
      // width: 100%;
      border-radius: 8px;
      background-color: #fff;
      padding: 16px 15px 16px 24px;
     .pjjyTitle{
        font-weight: 500;
        font-size: 16px;
        color: #333;
        padding-bottom: 14px;
     }
     .pjjyContent{
       width: 325px;
       border-radius: 4px;
       padding: 14px 12px;
       textarea{
         font-size: 14px;
         font-weight: 400;
         color: #333;
         border: 0.5px solid #e5e5e5;
         padding: 15px;
       }
     }
   }
   .pjButton{
     background-color: #fff;
     padding: 10px 15px;
     margin: -15px -10px;
     input{
       font-weight: 500;
       font-size: 18px;
       width: 45%;
       text-align: center;
       border: 1px solid #e5e5e5;
       border-radius: 25px;
     }
     .btnLfte{
       margin-left: 10px;
     }
     .btnRight{
       color:#fff;
       background-color: #2b67e1;
     }
   }
 }
</style>



// WEBPACK FOOTER //
// src/components/teacher/jspx/jspxkc_edit.vue